import React, { Component } from "react";
import Select from "react-select";
import { immediateToast } from "izitoast-react";

import { connect } from "react-redux";
import { callAPI } from "../../assets/Js/backendCommunication";
import { Spinner } from "../../Components/Spinner/Spinner";
import { withRouter } from "react-router-dom";

import projectSettings from "../../assets/Js/projectSettings";

import { Select_Option } from "../../assets/Js/errorMessage";

import selectGym from "../../redux/actionCreators/selectGym";
import gymList from "../../redux/actionCreators/gymList";
import addConnectedAccountId from "../../redux/actionCreators/addConnectedAccountId";

import { getPlainToken, getToken } from "../../assets/Js/tokenHandler";

const mapDispatchToProps = (dispatch) => {
  return {
    addGymData: (data) => dispatch(gymList(data)),
    selectedGym: (data) => dispatch(selectGym(data)),
    connectedAccountId: (id) => dispatch(addConnectedAccountId(id)),
  };
};
const mapStateToProps = (state) => ({
  athleteAccountId: state.athleteAccountId,
  userData: state.userData,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    class JoinGym extends Component {
      constructor(props) {
        super(props);

        this.state = {
          showSuggestions: false,
          isLoading: false,
          showError: false,
          selectedGym: "",
          gmyIds: [],
          gyms: [],
          options: [],
        };
      }

      componentDidMount() {
        this.getGyms();
      }

      componentDidUpdate(prevProps, prevState) {
        if (prevProps.userData.Id !== this.props.userData.Id) {
          this.getGyms();
        }
      }

      submitHandler = () => {
        if (this.state.selectedGym) {
          let index = this.state.gyms.find(
            (item) => item.Id === this.state.selectedGym.value
          );
          this.props.selectedGym(this.state.selectedGym);

          getPlainToken()
            ? this.move()
            : this.props.setNextPage({ whichAccount: "AddProfilePicture" });
        } else {
          immediateToast("warning", {
            message: Select_Option,
          });
        }
      };

      move = async () => {
        if (this.props.spin) {
          await this.setState({ isLoading: true });
          if (await this.props.move()) {
            this.setState({ isLoading: false });
          }
        } else {
          this.props.move();
        }
      };

      skipHandler = () => {
        this.props.setNextPage({ whichAccount: "AddProfilePicture" });
      };

      getGyms = async () => {
        let userId = getPlainToken() ? this.props.userData.Id : this.props.match.params.id;
        let _baseUrl = projectSettings.baseUrl + "/gyms";
        let _url = userId ? `${_baseUrl}?userId=${userId}` : _baseUrl;

        let url = _url;
        let header = true;
        let type = "GET";
        let token = null;
        let data = null;

        let response = "";

        if (response === "") {
          this.setState({ isLoading: true });
        }

        response = await callAPI(url, header, type, data, token);

        if (response) {
          this.setState({ isLoading: false });
          if (response.type === "error") {
          } else if (response.type === "success") {
            this.props.addGymData(response.data);

            let gym = response.data.map((gym) => ({
              name: gym.Name,
              id: gym.Id,
              connectedAccountId: gym.StripeConnectedAccountId,
            }));
            const tempOptions = gym.map((currVal, index) => ({
              value: currVal.id,
              label: currVal.name,
              connectedAccountId: currVal.connectedAccountId,
            }));

            this.setState({ gyms: response.data, options: tempOptions });
            response = "";
          }
        }
      };

      render() {
        return (
          <div className={"p-0"}>
            <h6>Join Your Gym</h6>
            <div className="mt-3">
              <Select
                className="react-select"
                options={this.state.options}
                onChange={(selectedOption) => {
                  this.props.connectedAccountId(
                    selectedOption.connectedAccountId
                  );
                  this.setState({ selectedGym: selectedOption });
                }}
              />
            </div>
            <div
              className={`d-flex ${
                getPlainToken()
                  ? "justify-content-end"
                  : "justify-content-center"
              } mt-3 mb-3`}
            >
              {getPlainToken() && (
                <button
                  className={`basicFatBtnStyle quaternaryColor colorDark mr-2`}
                  data-dismiss="modal"
                  onClick={this.props.resetOnCloseModal}
                >
                  Cancel
                </button>
              )}

              <button
                type="submit"
                className="basicFatBtnStyle primaryBtn"
                onClick={this.submitHandler}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? (
                  <div>
                    <Spinner />
                  </div>
                ) : (
                  <div>Next</div>
                )}
              </button>
            </div>
          </div>
        );
      }
    }
  )
);
